/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionIn } from './TransactionIn';
import {
    TransactionInFromJSON,
    TransactionInFromJSONTyped,
    TransactionInToJSON,
} from './TransactionIn';

/**
 * 
 * @export
 * @interface TransactionsTransactionIn
 */
export interface TransactionsTransactionIn {
    /**
     * 
     * @type {Array<TransactionIn>}
     * @memberof TransactionsTransactionIn
     */
    value?: Array<TransactionIn>;
}

/**
 * Check if a given object implements the TransactionsTransactionIn interface.
 */
export function instanceOfTransactionsTransactionIn(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TransactionsTransactionInFromJSON(json: any): TransactionsTransactionIn {
    return TransactionsTransactionInFromJSONTyped(json, false);
}

export function TransactionsTransactionInFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionsTransactionIn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : ((json['value'] as Array<any>).map(TransactionInFromJSON)),
    };
}

export function TransactionsTransactionInToJSON(value?: TransactionsTransactionIn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value === undefined ? undefined : ((value.value as Array<any>).map(TransactionInToJSON)),
    };
}

